import optimizely from '@optimizely/optimizely-sdk';
import optimizelyConfig from './config';

export const createOptimizelyClient = (config) => {
  const { OPTIMIZELY_SDK_KEY } = config;
  if (!OPTIMIZELY_SDK_KEY) {
    // eslint-disable-next-line no-console
    console.error('An Optimizely SDK key was not provided.');

    return {
      track: () => {}
    };
  }

  return optimizely.createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY
  });
};

export default Object.freeze(createOptimizelyClient(optimizelyConfig));
